import React from 'react'
import Product from './Product'

export default function Recommended({products}) {

    let filteredProducts = products?.filter(product => product?.recommended === true);
  return (
    <section className="w-full h-fit py-12">
        <div className="mxw">
            {/* section heaing */}
            <div className="w-full h-fit py-4 text-left">
                <p className="text-2xl md:text-3xl font-semibold">Our recommendations</p>
            </div>
        </div>
        {/* <div className="mxw grid overflow-auto scrollbar-hide grid-flow-col-dense md:grid-cols-4 py-12 gap-2 md:gap-4"> */}
        <div className="mxw grid overflow-auto scrollbar-hide grid-flow-col-dense auto-cols-auto py-12 gap-2 md:gap-4">
            {filteredProducts?.slice(0,4)?.map(product => (
                <div className="min-h-64 w-64 md:w-96 md:min-h-96">
                    <Product key={product?.id} product={product} />
                </div>
            ))}
        </div>

    </section>
  )
}
